import React from 'react';
import PropTypes from 'prop-types';
import {InferPropTypes} from 'commons/types/Types';
import {FormikErrors, withFormik} from 'formik';
import {Messages} from 'commons/constants';
import {TaxIdValues} from 'commons/models/modules/content/TaxIdValues';
import InnerFormTaxId from './InnerFormTaxId';

TaxIdForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    taxId: PropTypes.any
};

const FormControl = withFormik<
    InferPropTypes<typeof TaxIdForm.propTypes>,
    TaxIdValues
>({
    mapPropsToValues: (props) => {
        return {
            file: props.taxId ||  '',
        };
    },
    validateOnChange: true,
    validate: (values: TaxIdValues) => {
        const errors: FormikErrors<TaxIdValues> = {};
        if (!values.file) {
            errors.file = Messages.FILE_NOT_SELECTED;
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler(values);
    },
})(InnerFormTaxId);

function TaxIdForm(props: InferPropTypes<typeof TaxIdForm.propTypes>) {
    const {submitHandler, taxId} = props;
    return (
        <div className='TaxIdForm'>
            <FormControl
                // eslint-disable-next-line react/jsx-handler-names
                submitHandler={submitHandler}
                taxId={taxId}
            />
        </div>
    );
}

export default TaxIdForm;
